// Constellation
import { Box, LabeledControl, Paragraph, Radio, Text, ToggleCard } from '@zillow/constellation-10';

// Types
type PriceCardPropTypes = {
  description: string;
  handleClick?: () => void;
  isActive: boolean;
  isDisabled?: boolean;
  title: string;
};

const PriceCard = ({
  description,
  isDisabled = false,
  handleClick = () => {},
  isActive,
  title,
}: PriceCardPropTypes) => {
  const text = (
    <Box css={{ marginLeft: '300' }}>
      <Text textStyle="body-bold">{title}</Text>
      <Paragraph textStyle="body-sm" color="text.subtle">
        {description}
      </Paragraph>
    </Box>
  );
  return isDisabled ? (
    <ToggleCard elevated={false} tone="neutral" css={{ marginBottom: '400' }}>
      {text}
    </ToggleCard>
  ) : (
    <ToggleCard elevated={false} tone="neutral" selected={isActive} onClick={handleClick} css={{ marginBottom: '400' }}>
      <LabeledControl
        control={<Radio name="distance" checked={isActive} css={{ minWidth: '20px', marginRight: '200' }} />}
        label={text}
      />
    </ToggleCard>
  );
};

export default PriceCard;
